import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { toDto as toReservationDto } from '../../../models/adapters/ReservationSettingsAdapter';
import {
  reservationSettingSaved,
  reservationSettingSaveFailed,
  saveReservationSetting,
  SaveReservationSettingActionType,
} from '../../actions/setting/saveReservationSetting';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* saveReservationSettingsSaga({ payload }: SaveReservationSettingActionType) {
  const { reservationSetting } = payload;
  const token = yield getAuthenticationToken();
  const reservationSettingDto = toReservationDto(reservationSetting);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.updateReservationSetting, token, {
    reservationSettingDto,
  });
  const timestamp = moment();
  if (!response.error) {
    yield put(reservationSettingSaved({ reservationSetting, timestamp }));
  } else {
    yield put(
      reservationSettingSaveFailed({
        placeUuid: reservationSetting.placeUuid,
        reservationSettingUuid: reservationSetting.uuid,
        timestamp,
      })
    );
  }
}

export default function* watchSaveReservationSettingsSaga() {
  yield takeEvery(saveReservationSetting, saveReservationSettingsSaga);
}
